import React, {ReactElement} from 'react';
import {useUIStore} from 'store/UI';
import {Animate} from 'components/Animate';
import {History} from 'components/History';

export const HistoryView = (): ReactElement => {
  const {historyVisible} = useUIStore();

  return (
    <Animate mount={historyVisible}>
      <History />
    </Animate>
  );
};
